import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory, useParams } from 'react-router-dom'

import { LOGIN_PATH } from 'account/login/Login'
import { Layout as AntLayout, Col, Menu, Row } from 'antd'
import Logo from 'ichraDecisionTool/common/Logo'

import IchraDesicisionToolSuccess from 'assets/images/IchraDesicisionToolSuccess'

interface Props {}

export const SIGNUP_COMPLETE_PATH = 'signup-complete'

const SignupComplete: React.FC<Props> = () => {
  const { t: translate } = useTranslation('ichra-decision-tool')
  let { companyName } = useParams<any>()
  const history = useHistory()
  useEffect(() => {
    if (!companyName) {
      history.push(LOGIN_PATH)
    }
  }, [])
  return (
    <AntLayout>
      <Menu mode="horizontal">
        <Menu.Item>
          <Logo />
        </Menu.Item>
      </Menu>
      <AntLayout className="dashboard_body">
        <AntLayout className="dashboard-layout-content">
          <div className="flex flex__center">
            <IchraDesicisionToolSuccess />
          </div>

          <div className="flex flex__center mt-24">
            <div className="width_40">
              <div>
                <div className="flex flex__center">
                  <h2>{translate('prospect-signup.step-3.congratulations-header').replace('[]', companyName ?? '')}</h2>
                </div>
                <p className="color-gray-8">{translate('prospect-signup.step-3.congratulations-message')}</p>
              </div>
            </div>
          </div>
        </AntLayout>
      </AntLayout>
    </AntLayout>
  )
}

export default SignupComplete
